import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

import { useTownAssets } from '../../stores';
import secondFactorLabelOk from '../../utils/secondFactor/secondFactorLabelOk';
import { Column, Row } from '../display';
import { TextInput } from '../input';

function TotpEnrollScan(props) {
  const {
    uri,
    secret,
    label,
    onLabelChange,
    code,
    onCodeChange,
    onEnter,
    disabled = false,
  } = props;
  const { assets } = useTownAssets();
  const { translate } = assets;

  const handleKeyDown = (event) => {
    if ((event.key === 'Enter') && onEnter) onEnter();
  };

  return (
    <Column gap={3} crossStart>
      <span>{translate('secondFactorScanQrCode', 'statements')}</span>

      <QRCodeSVG value={uri} size={200} className="self-center" />

      <span className="text-sm">
        {`${translate('secondFactorManualKey', 'statements')}: `}
        <span className="font-mono font-semibold break-all">{secret}</span>
      </span>

      <Row gap={2}>
        <span>{`${translate('name')} :`}</span>

        <TextInput
          id="secondFactorLabel"
          name="secondFactorLabel"
          value={label}
          onChange={(event) => onLabelChange(event.target.value)}
          invalid={!secondFactorLabelOk(label.trim())}
          widthChars={30}
          disabled={disabled}
        />
      </Row>

      {(secondFactorLabelOk(label.trim()))
        ? null
        : <span>{translate('secondFactorLabelRefused', 'statements')}</span>}

      <TextInput
        id="secondFactorConfirmCode"
        name="secondFactorConfirmCode"
        fillType="oneTimeCode"
        value={code}
        onChange={(event) => onCodeChange(event.target.value.replaceAll(/\D/g, '').slice(0, 6))}
        onKeyDown={handleKeyDown}
        placeholder={translate('sixDigitCode', 'statements')}
        widthChars={16}
        disabled={disabled}
        focus
      />
    </Column>
  );
}

TotpEnrollScan.propTypes = {
  uri: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  code: PropTypes.string.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  disabled: PropTypes.bool,
};

export default TotpEnrollScan;
